import styled from "styled-components";
import {
  GridColDef,
  GridFilterModel,
  GridValueFormatterParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { getAllOrders } from "../../../services/orders/get-all";
import { useMutation, useQuery } from "@tanstack/react-query";
import { LoadingBackDrop } from "../../../components/loader";
import { GetAllOrdersPayload } from "../../../services/orders/get-all/types";
import { useNavigate } from "react-router-dom";
import { url, urlOperator } from "../../../utils/url";
import { styled as _styled } from "@mui/material/styles";
import { Button, IconButton } from "@mui/material";
import { theme } from "../../../helpers/theme";

import { getAllWarehouses } from "../../../services/warehouses/get-all";
import {
  GetAllWarehouses,
  WarehousesIsurance,
} from "../../../services/warehouses/get-all/types";
import { StyledTable } from "../../../components/table/styled-table";
import SessionService from "../../../services/session-service";
import { StyledButton } from "../../../components/Button/button";
import {
  FormWarehousesData,
  WarehousesDataEdite,
} from "../operator-subcontractors-warehouses-edit/components/forms/data-warehouses-edite";
import {
  FormWarehousesAddress,
  WarehousesAdresEditeEdite,
} from "../operator-subcontractors-warehouses-edit/components/forms/adres-warehouses-edite";
import { OperatorSubcontractorWarehousesEdite } from "../operator-subcontractors-warehouses-edit";
import { dateFormating } from "../operator-orders-offering/helpers";
import {
  ShortMenuBox,
  WarehousesIsuranceDataTableProps,
} from "../operator-subcontractors-warehouses-insurance/components/short-menubutton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import OperatorSubcontractorWarehousesEditAvailability from "../operator-subcontractors-edit-availability-from-file/OperatorSubcontractorWarehousesEditAvailability";

interface warehousesEditedProps {
  warehouses_data: FormWarehousesData;
  warehouses_adress: FormWarehousesAddress;
}
const OperatorSubcontractors = () => {
  const navigate = useNavigate();

  //*Obsługa Modala-Edycja Warehouse-Start */
  const [open, setOpen] = useState(false);
  const [openAvailability, setOpenAvailability] = useState(false);
  const [insuranceAdded, setInsuranceAdded] = useState(false);
  const [insuranceDeleted, setInsuranceDeleted] = useState(false);
  const [insuranceUpdated, setInsuranceUpdated] = useState(false);
  const [subcontractorsPage, setSubcontractorsPage] = useState(0);
  const [subcontractorsFilters, setSubcontractorsFilters] =
    useState<GridFilterModel>();

  const handleSubcontractorsPageChange = (params: any) => {
    setSubcontractorsPage(params);
  };

  const handleSubcontractorsFilterChange = (params: any, event?: any) => {
    const newFilters = params;
    setSubcontractorsFilters(newFilters);
  };

  useEffect(() => {
    // Load state from session storage
    const savedPage = sessionStorage.getItem("Subcontractors-page");
    if (savedPage !== null && savedPage !== undefined) {
      setSubcontractorsPage(parseInt(savedPage));
    }
    const savedFilters = sessionStorage.getItem("Subcontractors-filters");
    if (savedFilters !== null && savedFilters !== undefined) {
      try {
        setSubcontractorsFilters(JSON.parse(savedFilters));
      } catch (e) {
        console.error("Error parsing saved filters:", e);
      }
    }
  }, []);

  useEffect(() => {
    // Save state to session storage
    if (subcontractorsPage !== 0 && subcontractorsPage !== undefined) {
      sessionStorage.setItem(
        "Subcontractors-page",
        subcontractorsPage.toString()
      );
    }
    if (subcontractorsFilters !== undefined) {
      sessionStorage.setItem(
        "Subcontractors-filters",
        JSON.stringify(subcontractorsFilters)
      );
    }
  }, [subcontractorsPage, subcontractorsFilters]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenAvailability = () => {
    setOpenAvailability(true);
  };
  const handleCloseAvailability = () => {
    setOpenAvailability(false);
  };

  const [warehousesEdited, setWarehousesEdited] = useState({
    warehouses_data: {
      id_magazyn: "",
      kod_magazynu: "",
      opis: "",
      powierzchnia_procentowa: 0,
      klasa_magazynu: 0,
      medyczny: false,
      adres_id: "",
    },
    warehouses_adress: {
      id_magazyn: "",
      kod_pocztowy: "",
      miejscowosc_poczty: "",
      miejscowosc: "",
      ulica: "",
      numer_budynku: "",
      numer_lokalu: "",
      wojewodztwo: "",
      kraj: "",
    },
  });
  //*Obsługa Modala-Stop */

  const reGetAllWarehouses = useMutation(getAllWarehouses, {
    onSuccess: (data) => {
      setWarehouses(data.data.payload.magazyny);
    },
  });

  useEffect(() => {
    reGetAllWarehouses.mutate({
      paginacja: null,
    });
    setInsuranceDeleted(false);
    setInsuranceAdded(false);
    setInsuranceUpdated(false);
  }, [insuranceAdded, insuranceDeleted, insuranceUpdated]);

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 430,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.blue01_active,
              marginLeft: 0,
            }}
            onClick={() => {
              SessionService.setSubcontractors(params.row.wykonawcy);
              navigate(urlOperator.subcontractorsDetails);
            }}
          >
            Dane Podwykonawcy
          </Button>

          <Button
            variant="contained"
            style={{
              backgroundColor: "orange",
            }}
            onClick={() => {
              return navigate(
                `/operator/subcontractors/storage-area/${params.id}`
              );
            }}
          >
            Obszary Składowania
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "magenta",
              width: "110px",
            }}
            onClick={() => {
              return navigate(`/operator/subcontractors/services/${params.id}`);
            }}
          >
            Usługi
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "green",
              width: "110px",
            }}
            onClick={() => {
              return navigate(
                `/operator/subcontractors/price-list/${params.id}`
              );
            }}
          >
            Cennik
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "orange",
              width: "110px",
            }}
            onClick={() => {
              handleOpen();
              setWarehousesEdited(params.row.magazyn_edited);
            }}
          >
            Edytuj
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "black",
              width: "3px",
            }}
            onClick={() => {
              return navigate(`/operator/subcontractors/gallery/${params.id}`);
            }}
          >
            <PhotoCamera />
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "red",
              width: "3px",
            }}
            onClick={() => {
              return navigate(`/operator/warehouse/delete/${params.id}`);
            }}
          >
            Usuń 
          </Button>
        </>
      ),
    },
    { field: "podwykonawca", headerName: "Podwykonawca", width: 180 },
    // {
    //   field: "ubezpieczenie1",
    //   type: "date",
    //   valueFormatter: (params: GridValueFormatterParams) => {
    //      return dateFormating(params.value) === "Invalid Date"
    //        ? "-"
    //        : dateFormating(params.value);
    //    },
    //   valueGetter: (params: GridValueGetterParams) => {
    //     return params.value;
    //   },
    //   headerName: "Ubezpieczenie1",
    //   width: 150,
    // },
    {
      field: "ubezpieczenie",
      valueGetter: (params: GridValueGetterParams) => {
        return params.value?.ubezpieczenie
          ? params.value.ubezpieczenie?.data_zakonczenia
            ? params.value.ubezpieczenie.data_zakonczenia
            : "Invalid Date"
          : "Invalid Date";
      },
      headerName: "Ubezpieczenie",
      width: 280,
      renderCell: (params) => (
        <ShortMenuBox
          data={params.row.ubezpieczenie}
          insuranceAdded={insuranceAdded}
          setInsuranceAdded={setInsuranceAdded}
          insuranceDeleted={insuranceDeleted}
          setInsuranceDeleted={setInsuranceDeleted}
          insuranceUpdated={insuranceUpdated}
          setInsuranceUpdated={setInsuranceUpdated}
        />
      ),
    },
    {
      field: "lokalizacja_magazynu",
      headerName: "Lokalizacja Magazynu",
      width: 300,
    },
    { field: "powierzchnia", headerName: "% Powierzchni", width: 150 },
    { field: "klasa", headerName: "Klasa", width: 100 },
    { field: "medyczny", headerName: "Medyczny", width: 100 },
    {
      field: "opis",
      headerName: "Opis",
      width: 300,
    },
  ];

  const [warehouses, setWarehouses] = useState<GetAllWarehouses[]>([]);

  const body = {
    paginacja: null,
  };

  const { isLoading, isRefetching } = useQuery(
    ["warehouses"],
    () => getAllWarehouses(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        //console.log("Data:", data.data.payload.magazyny[0].ubezpieczenie.data_zakonczenia);
        setWarehouses(data.data.payload.magazyny);
      },
    }
  );

  const getMagazineClassFromEnum = (type: number) => {
    switch (type) {
      case 0:
        return "A++";
      case 1:
        return "A+";
      case 2:
        return "A";
      case 3:
        return "B";
    }
  };

  const rows = warehouses.map((r: GetAllWarehouses) => ({
    id: r.id_magazyn,
    podwykonawca: r.kod_magazynu,
    lokalizacja_magazynu: r.adres
      ? `${r.adres?.kod_pocztowy && r.adres?.kod_pocztowy} ${
          r.adres?.miejscowosc
        }${
          r.adres?.ulica
            ? `, ${r.adres.ulica} ${
                r.adres?.numer_budynku ? r.adres?.numer_budynku : ""
              } ${r.adres?.numer_lokalu ? "/" + r.adres.numer_lokalu : ""}`
            : ` ${
              r.adres?.numer_budynku ? r.adres?.numer_budynku : ""
            } ${r.adres?.numer_lokalu ? "/" + r.adres.numer_lokalu : ""}`
        }`
      : "Brak Danych",
    powierzchnia: r.powierzchnia_procentowa,
    // ubezpieczenie1: r.ubezpieczenie?.data_zakonczenia
    //   ? dateFormating(r.ubezpieczenie?.data_zakonczenia)
    //   : "-",
    ubezpieczenie: {
      ubezpieczenie: r?.ubezpieczenie ? r?.ubezpieczenie : null,
      magazyn_id: r.id_magazyn,
    },
    klasa: getMagazineClassFromEnum(r.klasa_magazynu),
    medyczny: r.medyczny ? "Tak" : "Nie",
    opis: r.opis,
    wykonawcy: r.wykonawcy,
    magazyn_edited: {
      warehouses_data: {
        id_magazyn: r.id_magazyn,
        kod_magazynu: r.kod_magazynu,
        opis: r.opis,
        powierzchnia_procentowa: r.powierzchnia_procentowa,
        klasa_magazynu: r.klasa_magazynu,
        medyczny: r.medyczny,
        adres_id: r.adres.id_adres,
      },
      warehouses_adress: {
        id_magazyn: r.id_magazyn,
        kod_pocztowy: r.adres.kod_pocztowy,
        miejscowosc_poczty: r.adres.miejscowosc_poczty,
        miejscowosc: r.adres.miejscowosc,
        ulica: r.adres.ulica,
        numer_budynku: r.adres.numer_budynku,
        numer_lokalu: r.adres.numer_lokalu,
        wojewodztwo: r.adres.wojewodztwo,
        kraj: r.adres.kraj,
      },
    },
  }));

  if (isLoading || isRefetching || reGetAllWarehouses.isLoading) {
    return <LoadingBackDrop loading={true} />;
  }

  const forms = [
    <WarehousesDataEdite
      handleClose={handleClose}
      setWarehouses={setWarehouses}
      warehouses_data={warehousesEdited.warehouses_data}
    />,
    <WarehousesAdresEditeEdite
      handleClose={handleClose}
      setWarehouses={setWarehouses}
      warehouses_address={warehousesEdited.warehouses_adress}
    />,
  ];

  return (
    <>
      <SubcontractorsContainer>
        <AddSubcontractorButtonWrapper>
          <StyledButton
            variant="contained"
            onClick={() => {
              return navigate(urlOperator.subcontractorsAddSubcontractor);
            }}
          >
            Dodaj Podwykonawcę
          </StyledButton>
          <StyledButton
            style={{ marginLeft: "10px" }}
            variant="contained"
            onClick={()=>handleOpenAvailability()}
          >
            Edytuj dostępność z pliku
          </StyledButton>
        </AddSubcontractorButtonWrapper>
        <StyledOperatorTable
          getRowId={(row: any) => row?.id}
          rows={rows}
          columns={columns}
          page={subcontractorsPage}
          filterModel={subcontractorsFilters}
          onPageChange={handleSubcontractorsPageChange}
          onFilterModelChange={handleSubcontractorsFilterChange}
          autoPageSize
        />
      </SubcontractorsContainer>

      {/* Modal do Edycji*/}
      <OperatorSubcontractorWarehousesEdite
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        forms={forms}
      />
      {/* Modal do dodawania pliku edycji dostępności */}
      <OperatorSubcontractorWarehousesEditAvailability
        openAvailability = {openAvailability}
        // handleOpen={handleOpenAvailability}
        handleCloseAvailability = {handleCloseAvailability}
      />
    </>
  );
};

export default OperatorSubcontractors;

const SubcontractorsContainer = styled.div`
  height: 80vh;

  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
const AddSubcontractorButtonWrapper = styled.div`
  display: flex;
  margin-bottom: 30px;
`;
export const StyledOperatorTable = _styled(StyledTable)({
  ".row-style": {
    maxHeight: "125px !important",
    height: "125px",
  },

  "& .MuiDataGrid-cell": {
    maxHeight: "100% !important",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: "8px 10px ",
  },
});

const InsuranceWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
const InsuranceAction = styled.div`
  display: flex;
  flex-direction: column;
`;
